import React, { FC, useContext, useEffect, useMemo } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import BookingContext from '../contexts/booking'

const BookingPaymentConfirm: FC<React.PropsWithChildren<unknown>> = () => {
  const booking = useContext(BookingContext)

  const html = useMemo(() => {
    return {
      confirmation_header: booking.generalConfig.confirmation_header ? booking.renderLayout(booking.generalConfig.confirmation_header) : '',
      confirmation_footer: booking.generalConfig.confirmation_footer ? booking.renderLayout(booking.generalConfig.confirmation_footer) : '',
    }
  }, [
    booking.generalConfig,
    booking.renderLayout,
  ])

  useEffect(() => {
    if(!booking.initialised) return
    booking.confirmPayment()
  }, [
    booking.initialised,
  ])

  return (
    <Box sx={{ display: 'flex', p: 2 }}>
      {
        booking.confirmedBooking ? (
          <>
            {
              html.confirmation_header && (
                <Box sx={{ my: 2 }}>
                  <div dangerouslySetInnerHTML={{__html: html.confirmation_header}} />
                </Box>
              )
            }
            <Box sx={{ my: 2 }}>
              <Typography
                variant="h3"
                color="primary"
                gutterBottom
              >
                { booking.confirmedBooking.data.reference }
              </Typography>
            </Box>
            <Box sx={{ my: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                sx={{ mt: 2 }}
                disabled={ booking.loading }
                onClick={ () => {
                  booking.clearConfirmPayment()
                } }
              >
                Manage Booking
              </Button>
            </Box>
            {
              html.confirmation_footer && (
                <Box sx={{ my: 2 }}>
                  <div dangerouslySetInnerHTML={{__html: html.confirmation_footer}} />
                </Box>
              )
            }
          </>
        ) : (
          <>
            <Box sx={{ my: 2 }}>
              waiting for confirmation of payment...
            </Box>
            {
              booking.confirmError && (
                <Typography color="error">
                  { booking.confirmError }
                </Typography>
              )
            }
          </>
        )
      }
      {
        booking.loading && (
          <Box sx={{ my: 2 }}>
            <CircularProgress />
          </Box> 
        )
      }
    </Box>
  )
}

export default BookingPaymentConfirm